import { SectionHead } from "@/components/site/SectionHead";
import { Reveal } from "@/components/site/Reveal";

const rows = [
  ["Material", '14 GA. steel plate'],
  ["Overall length", '6 3/16"'],
  ["Span between end tabs", '4 3/16"'],
  ["End tab width", '1" each'],
  ["Overall height", '2 3/16"'],
  ["Base plate width", '1"'],
  ["Fastener holes", '7/32" dia.'],
  ["Included fasteners", '#10 × 3/4" pan head, self-drilling'],
  ["Fasteners — post", "2 minimum per post"],
  ["Fasteners — rail", "4 minimum per bracket"],
  ["Mount styles", "Flush or bypass"],
  ["Patent status", "Patent Pending 19/642,047"],
];

export const Specs = () => (
  <section className="section" data-testid="specs-section">
    <div className="wrap">
      <SectionHead num="05" eyebrow="Specifications" title="Bracket 200." />
      <Reveal>
        <div className="spec-scroll" data-testid="spec-table-scroll">
          <table className="spec-table">
            <thead>
              <tr>
                <th scope="col">Attribute</th>
                <th scope="col">Value</th>
              </tr>
            </thead>
            <tbody>
              {rows.map(([k, v]) => (
                <tr key={k}>
                  <td>{k}</td>
                  <td>{v}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Reveal>
    </div>
  </section>
);
